// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"ModalContent__modalContent___2KRn-","inset":"ModalContent__inset___2zvYE","mobile":"ModalContent__mobile___36cJA"};